export default {
    bot_description: "Опис бота",
    bot_name: "Ім'я бота",
    clinic_account: "Аккаунт клініки",
    clinic_site_link: "Посилання на сайт клініки",
    code_for_bonus_payment: "Код для оплати бонусами",
    code_was_not_sent: "Код не був надісланий - пацієнту потрібно перевірити підключення до телеграм бота",
    code_was_sent_to_patient_through_bot: "Код був надісланий пацієнту через телеграм бота",
    connected_to_telegram_bot: "Підключено до телеграм бота",
    max_bot: "Max bot",
    telegram_bot: "Telegram bot",
    telegram_bot_default_description: "Бот допомагає пацієнтам клініки накопичувати бонуси та отримувати актуальну інформацію про візити",
    telegram_bot_instruction_1: "Відкрийте месенджер Telegram, увійдіть до вашого облікового запису або створіть новий. Введіть у поле пошуку <code>{'@'}BotFather</code> та виберіть бот",
    telegram_bot_instruction_2: "Виберіть або надрукуйте та надішліть <code>/newbot</code>",
    telegram_bot_instruction_3: "Дайте ім'я боту - клієнти побачать це ім'я під час спілкування з ботом. І нікнейм бота - по ньому можна буде знайти бота в Telegram. Нікнейм має бути унікальним, не повторювати існуючі в базі та закінчуватися на слово bot",
    telegram_bot_instruction_4: "Скопіюйте значення токена у створеного бота, вставте в поле нижче та збережіть",
    use_bonuses_by_confirming_through_telegram_bot: "Списання бонусів із підтвердженням через Телеграм бота",
    wrong_code: "Код невірний"
}
